/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable max-len */
/* eslint-disable object-property-newline */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Layer } from 'react-mapbox-gl';
import { withResizeDetector } from 'react-resize-detector';
import { UI, Selection } from '@leverege/ui-redux';
import { Toolbar } from '@leverege/ui-plugin';
import { ValuesCache } from '@leverege/value-cache';
import { DataSources } from '@leverege/ui-attributes';
import { Config } from '@leverege/plugin';
import { RolloverSelectionPointer, ReduxMapOptions, MapControl, Map } from '@leverege/ui-mapbox-elements';
import { DashboardContextConsumer } from '@leverege/ui-dashboard';
import { Relationship } from '@leverege/molten-core';
import SymbolSet from "./SymbolSet.js";
import GeoUtil from "../shared/GeoUtil.js";
import MapProvider from "./MapProvider.js";
import PluginUtils from "../shared/PluginUtils.js";
import S from './MapView.css';
import Model from "../shared/models/MapViewerModel.js";
import GeoJsonPointer from "../../../imagine/map/GeoJsonPointer.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let gsym = null;
const MAX_SORT_LAYERS = 15;
class MapView extends React.Component {
  static GeoJsonPointerType = GeoJsonPointer;
  constructor(props) {
    super(props);
    const {
      mapName
    } = props;
    const pointer = new RolloverSelectionPointer();
    this.caches = new ValuesCache();
    this.recomputeBounds = true;
    // eslint-disable-next-line react/destructuring-assignment
    this.mapOptions = new ReduxMapOptions({
      context: {}
    }, mapName, {
      UI
    }, props.dispatch);
    // Set up default ordering layers
    this.layers = [];
    let last = 'normal';
    for (let n = 0; n < MAX_SORT_LAYERS; n++) {
      const k = `normal-${n}`;
      this.layers[n] = /*#__PURE__*/_jsx(Layer, {
        id: k,
        before: last
      }, k);
      last = k;
    }
    this.state = {
      ...this.getStateFromMetadata(props),
      symbols: gsym,
      pointer
    };
    this.centerOnParent = this.state.center == null && this.state.mapBounds == null;
  }
  setPointer(pointer) {
    const {
      pointer: curr
    } = this.state;
    if (curr && typeof curr.onPointerRemoved === 'function') {
      curr.onPointerRemoved();
    }
    if (pointer && typeof pointer.onPointerInstalled === 'function') {
      pointer.onPointerInstalled(this.getContext());
    }
    if (pointer && typeof pointer.setPointerContext === 'function') {
      pointer.setPointerContext(this.getContext());
    }
    this.setState({
      pointer
    });
  }
  resetPointer() {
    this.setPointer(new RolloverSelectionPointer());
  }
  getContext = () => {
    return {
      client: 'MapDataViewer',
      clientProps: this.props,
      mapViewer: this
    };
  };
  onMoveEnd = () => {
    if (this.map) {
      const center = this.map.getCenter();
      const zoom = this.map.getZoom();
      this.setState({
        mapBounds: null,
        center: [center.lng, center.lat],
        zoom: [zoom],
        initialPadding: 0
      });
    }
  };
  onMapReady = map => {
    const {
      minZoom,
      maxZoom
    } = this.state;
    this.map = map;
    this.map.on('moveend', this.onMoveEnd);
    if (minZoom) {
      this.map.setMinZoom(minZoom);
    }
    if (maxZoom) {
      this.map.setMaxZoom(maxZoom);
    }
    this.forceUpdate();
  };
  componentDidUpdate(prevProps) {
    const {
      width,
      height,
      paginator,
      filters,
      selected,
      parentItem,
      mapName,
      loading
    } = this.props;
    if (width !== prevProps.width || height !== prevProps.height) {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1);
    }

    // Set the items in view
    if (this.map == null) {
      return;
    }
    const curr = this.currItems || {};
    const lastFilter = this.currFilter;
    let newFilter = false;
    if (!loading && prevProps.loading) {
      // finished loading.
      newFilter = lastFilter !== filters;
      this.currFilter = filters;
    }
    this.currItems = {
      page: paginator.page,
      count: paginator.count,
      items: paginator.pageItems
    };
    if (curr.page !== paginator.page || this.recomputeBounds && curr.count !== paginator.count || newFilter || this.recomputeBounds) {
      if (paginator.pageItems.length === 1 && paginator.pageItems[0]?.id === parentItem?.id) {
        return;
      }
      // Compute the view for the list of items
      const {
        bounds,
        point,
        zoom
      } = this.getAutoCenter(paginator.pageItems, {
        newFilter
      }) || {};
      if (bounds) {
        MapControl.flyToBounds(mapName, bounds, {
          padding: 60
        });
      } else if (point) {
        const curr = this.map.getZoom();
        // Don't feel like this should be here..
        const z = curr < 16.1 ? 18 : curr;
        MapControl.flyTo(mapName, {
          ...point,
          zoom: zoom === undefined ? z : zoom
        });
      } else {
        // nothing to fly to. CHECK THIS It was set to true ( for a reason )
        this.recomputeBounds = false;
      }
      if (bounds || point) {
        this.recomputeBounds = false;
        this.centerOnParent = false;
      }
    }
    // selection changed - make sure it is in view 
    if (prevProps.selected !== selected) {
      const arr = Selection.getSelected(selected);
      const c = this.getSelectionCenter(arr);
      if (c) {
        const {
          zoom,
          bounds,
          point
        } = c;
        if (bounds) {
          this.centerOnParent = false;
          MapControl.flyToBounds(mapName, bounds, {
            padding: 60
          });
        } else if (point) {
          this.centerOnParent = false;
          MapControl.flyTo(mapName, {
            ...point,
            zoom
          });
        }
      }
    }
  }
  componentDidMount() {
    const {
      mapName
    } = this.props;
    this._isMounted = true;
    this.symbols = new SymbolSet(s => {
      if (gsym || !this._isMounted) return;
      gsym = s.getImagesArray();
      this.setState({
        symbols: s.getImagesArray()
      });
    });

    // advertise as available
    MapProvider.set(this, mapName);
  }
  componentWillUnmount() {
    this._isMounted = false;
    const {
      mapName
    } = this.props;
    if (this.map) {
      this.map.off('moveend', this.onMoveEnd);
    }
    this.map = null;
    MapProvider.set(null, mapName);
  }

  /**
   * Cache and return the layer renderers to use
   */
  getSelectionCenterPlugins(objectType, path, relationship) {
    return PluginUtils.getSelectionCenterPlugins(this, objectType, path, relationship);
  }

  /**
   * Cache and return the layer renderers to use
   */
  getAutoCenterPlugins(objectType, path, relationship) {
    return PluginUtils.getAutoCenterPlugins(this, objectType, path, relationship);
  }

  /**
   * Cache and return the layer renderers to use
   */
  getRendererPlugins(objectType, path, relationship) {
    return PluginUtils.getRendererPlugins(this.caches, objectType, path, relationship);
  }
  getRenderers(symbols, items) {
    if (this.map == null) {
      return [];
    }
    const {
      relationship,
      delegate,
      settings: nModel,
      match,
      filters,
      dashboardContext,
      dataViewerCardModel
    } = this.props;
    const {
      path,
      objectType
    } = relationship;
    const plgs = this.getRendererPlugins(objectType, path, relationship);
    try {
      return [...this.layers, ...plgs.map((plg, index) => {
        const idx = Model.getLayerIndexByName(nModel, plg.layerName);
        if (idx < 0) {
          return null;
        }
        const model = Model.getLayer(nModel, idx);
        // nModel = Model.setLayer( nModel, plg.layerName, plg.createModel( model ) )
        return plg.create({
          map: this.map,
          symbols,
          filters,
          // the current groups filters
          relationship,
          model,
          match,
          items,
          delegate,
          order: Math.min(MAX_SORT_LAYERS - 1, idx),
          dataViewerCardModel,
          dashboardContext
        });
      })];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('MapView failed to create renderer', err);
    }
    return [];
  }
  render() {
    const {
      symbols,
      pointer,
      center,
      zoom,
      maxBounds,
      mapBounds,
      initialPadding = 0
    } = this.state;
    const {
      relationship,
      paginator,
      mapName,
      overrides,
      dataViewerId,
      settings
    } = this.props;
    const {
      path,
      objectType
    } = relationship;
    const hideTb = pointer && pointer.controlsScreenComponents === true;
    const layers = this.getRenderers(this.symbols, paginator.pageItems);
    const context = this.getContext();
    const matchContext = this.caches.calc('tbm', () => {
      return [{
        use: 'topLeftActionBar',
        client: 'MapDataViewer',
        objectType,
        path
      }, {
        use: 'topRightActionBar',
        client: 'MapDataViewer',
        objectType,
        path
      }, {
        use: 'bottomLeftActionBar',
        client: 'MapDataViewer',
        objectType,
        path
      }, {
        use: 'bottomRightActionBar',
        client: 'MapDataViewer',
        objectType,
        path
      }];
    }, objectType, path);
    if (pointer && typeof pointer.setPointerContext === 'function') {
      pointer.setPointerContext(context);
    }
    const ovrs = overrides.get(dataViewerId);
    const props = {
      key: mapName,
      mapName,
      maxBounds,
      pointer,
      zoom,
      useInitialPosition: false,
      symbols,
      layers,
      onMapReady: this.onMapReady,
      mapStyle: Model.getMapStyleUrl(settings, ovrs?.mapStyle)
    };
    if (mapBounds) {
      props.fitBounds = mapBounds;
      props.fitBoundsOptions = {
        animate: false,
        padding: initialPadding
      };
    } else {
      props.center = center;
    }
    return /*#__PURE__*/_jsxs("div", {
      className: S.content,
      children: [/*#__PURE__*/React.createElement(Map, props), !hideTb && /*#__PURE__*/_jsx(Toolbar, {
        className: classnames(S.toolbar, S.topLeft),
        variant: "mapActionBar||actionBar",
        prefer: "icon",
        matchContext: matchContext[0],
        context: context
      }), !hideTb && /*#__PURE__*/_jsx(Toolbar, {
        className: classnames(S.toolbar, S.topRight),
        variant: "mapActionBar||actionBar",
        prefer: "icon",
        matchContext: matchContext[1],
        context: context
      }), !hideTb && /*#__PURE__*/_jsx(Toolbar, {
        className: classnames(S.toolbar, S.bottomLeft),
        variant: "mapActionBar||actionBar",
        prefer: "icon",
        matchContext: matchContext[2],
        context: context
      }), !hideTb && /*#__PURE__*/_jsx(Toolbar, {
        className: classnames(S.toolbar, S.bottomRight),
        variant: "mapActionBar||actionBar",
        prefer: "icon",
        matchContext: matchContext[3],
        context: context
      })]
    }, "main");
  }
  getPathConfig(grp, key, dVal) {
    const {
      relationship
    } = this.props;
    const {
      path
    } = relationship;
    const pOpts = Config.get(grp, 'pathOptions', null);
    if (pOpts?.[path]?.[key] !== undefined) {
      return pOpts[path][key];
    }
    return Config.get(grp, key, dVal);
  }
  getAutoCenter(items, options) {
    // Find AutoCenter Plugins
    const {
      relationship
    } = this.props;
    const {
      path,
      objectType
    } = relationship;
    const plgs = this.getAutoCenterPlugins(objectType, path, relationship);
    const opts = {
      ...options,
      mapViewer: this
    };
    for (let n = 0; n < plgs.length; n++) {
      const c = plgs[n].calculateViewPosition(items, opts);
      if (c && typeof c === 'object') {
        return c;
      }
    }
    return GeoUtil.getBoundsOrPointFromItems(items);
  }
  getSelectionCenter(items) {
    // Find AutoCenter Plugins
    const {
      relationship,
      width,
      height
    } = this.props;
    const {
      path,
      objectType
    } = relationship;
    const plgs = this.getSelectionCenterPlugins(objectType, path, relationship);
    const opts = {
      mapViewer: this
    };
    for (let n = 0; n < plgs.length; n++) {
      const c = plgs[n].calculateViewPosition(items, opts);
      if (c && typeof c === 'object') {
        const keys = Object.keys(c);
        if (keys.length === 1 && keys[0] === 'zoom') {
          c.point = GeoUtil.getPosition(items[0]);
        }
        return c;
      }
    }
    const ll = GeoUtil.getPosition(items[0]);
    if (ll) {
      const pt = this.map.project([ll.lon, ll.lat]);
      const selectedZoom = this.getPathConfig('mapBoxPosition', 'selectedZoom', 18);
      const rezoom = this.getPathConfig('mapBoxPosition', 'selectedRezoomThreshold', 12);
      const cZoom = this.map?.getZoom() < rezoom ? selectedZoom : -1;
      if (pt.x < 20 || pt.y < 20 || pt.x > width - 20 || pt.y > height - 20 || cZoom !== -1) {
        return {
          point: ll,
          zoom: cZoom
        };
      }
    } else {
      const bnd = GeoUtil.getShapeBounds(items[0]);
      if (bnd) {
        return {
          bounds: bnd
        };
      }
    }
    return null;
  }
  getStateFromMetadata(props) {
    const {
      parentItem,
      paginator,
      filters,
      match,
      relationship
    } = props || this.props;
    const state = {};

    // Any items?
    this.currFilter = filters;
    this.currItems = {
      page: paginator.page,
      count: paginator.count,
      items: paginator.pageItems
    };
    const {
      bounds,
      point,
      zoom,
      useParent = true
    } = this.getAutoCenter(paginator.pageItems, {
      isInitial: true
    });
    if (bounds) {
      state.mapBounds = bounds;
      state.initialPadding = 60;
      state.center = null;
      this.currItems = {
        page: paginator.page,
        count: paginator.count,
        items: paginator.pageItems
      };
      this.recomputeBounds = false;
    } else if (point) {
      state.center = [point.lon, point.lat];
      this.currItems = {
        page: paginator.page,
        count: paginator.count,
        items: paginator.pageItems
      };
      this.recomputeBounds = false;
      if (zoom != null) {
        state.zoom = [zoom];
      }
    }
    if (useParent) {
      GeoUtil.getPositionFromObjRef(parentItem, state);
      GeoUtil.getConstraintsFromObjRef(parentItem, state);

      // Check parents. This will grab constaints as well and apply them from
      // up the tree if they have not been found already.
      const ancestors = Relationship.getObjectRefHierarchy(relationship, match);
      let n = 0;
      while (state.center == null && state.mapBounds == null && n < ancestors.length) {
        const objRef = DataSources.withData(ancestors[n++]);
        GeoUtil.getPositionFromObjRef(objRef, state);
        GeoUtil.getConstraintsFromObjRef(objRef, state);
      }
    }
    if (state.center == null && state.mapBounds == null) {
      // Default to give initial center
      state.center = Config.get('mapBoxPosition', 'center', [-77.1902656, 39.1081595]);
    }
    if (state.zoom == null && state.mapBounds == null) {
      state.zoom = [Config.get('mapBoxPosition', 'zoom', 18)];
    }
    return state;
  }
}
const withContext = Wrapped => function (props) {
  return /*#__PURE__*/_jsx(DashboardContextConsumer, {
    children: value => /*#__PURE__*/_jsx(Wrapped, {
      ...props,
      dashboardContext: value
    })
  });
};
export default connect((state, props) => {
  const {
    selectionKey,
    mapName = 'map'
  } = props;
  return {
    selected: Selection.get(state, selectionKey),
    mapName
  };
})(withContext(withResizeDetector(MapView)));